import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

export class SignIn extends Component {
    static displayName = SignIn.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            token: '',
        };
    }

    componentDidMount() {
        var token = new URLSearchParams(this.props.location.search).get("t");
        localStorage.setItem("_t", token);
        sessionStorage.setItem("_t", token);
        console.log('writed token');

        this.setState({ loading: false, token: token });
    }

    render() {
        if (this.state.loading)
            return (<div>אנא המתינו...</div>);

        var token = this.state.token;
        if (token === '') {
            return (
                <div>תהליך הזדהות נכשל</div>
            );
        }
        else if (token === 'NO_SEMEL') {
            return (
                <div>אינך שייך לאף בית ספר עם  הרשמה עצמאית</div>
            );
        }
        else return (
            <Redirect to="/" />
        );
    }
}